var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.162,
    height: 16.277,
    viewBox: "0 0 16.162 16.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52 -53.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.924,57.762h.819v8.961a3.02,3.02,0,0,1-3.02,3.02h-8.7A3.02,3.02,0,0,1,52,66.723v-8.7A3.02,3.02,0,0,1,55.021,55h8.7v.819h-8.7a2.2,2.2,0,0,0-2.2,2.2v8.7a2.2,2.2,0,0,0,2.2,2.2h8.7a2.2,2.2,0,0,0,2.2-2.2Z",
    transform: "translate(0 -0.339)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.475,56.043a1.229,1.229,0,0,0-1.737-1.737l-5.671,5.671.006,1.745,1.731-.006Zm.579-2.316a2.048,2.048,0,0,1,0,2.9l-5.791,5.791a.41.41,0,0,1-.288.12l-2.309.008a.41.41,0,0,1-.41-.41l-.008-2.324a.409.409,0,0,1,.12-.291l5.791-5.791a2.048,2.048,0,0,1,2.9,0Z",
    transform: "translate(-1.493 0)",
    fill: "#f18904"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.a731c5a558377bf5c57fcff3f956701f.svg";
export { ForwardRef as ReactComponent };